import React, { useEffect } from 'react';
import { ErrorSplash } from '@shared/components/ErrorSplash';
import { useTranslation } from '@shared/core';
import { withWindow } from '@shared/utils/withWindow';
import { useCardTelemetry } from '@apps/card/Card.telemetry';

export const Error: React.FC<{ orderNumber: string }> = ({ orderNumber }) => {
  const { tq } = useTranslation('cardGuest');
  const telemetry = useCardTelemetry();

  useEffect(() => {
    telemetry.premiumDigitalRecipientViewError({ orderNumber });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleNavigateToFindCouple = () => {
    withWindow(global => {
      global.location.href = '/find';
    });
  };

  return (
    <ErrorSplash
      customError={{
        title: tq`Hmm… we can't find that.`,
        subtitle: tq`This digital card may have been changed or is temporarily unavailable.`,
        linkText: tq`Find a Couple`,
      }}
      handleAction={handleNavigateToFindCouple}
    />
  );
};
